import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { Toast } from './toast.model';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  toasts = input<Toast[]>([]);

  dismissed = output<string>();

  protected onDismiss(id: string): void {
    this.dismissed.emit(id);
  }
}
